import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { CodeBlock, dracula } from "react-code-blocks";

export const LiveCodeBlock = ({
  code,
  language,
  live = true,
}: {
  code: string;
  language?: string;
  live?: boolean;
}) => (
  <Box position="relative">
    <CodeBlock
      text={code}
      theme={dracula}
      language={language ? language : "html"}
    />
    {live && (
      <Button
        variant="contained"
        size="small"
        sx={{ position: "absolute", top: 8, right: 8 }}
        onClick={() => {
          let html = code.replaceAll(
            'src="/presentation-data',
            `src="${window.location.origin}/presentation-data`
          );

          html += "<style>* { font-size: 40px } body {padding: 100px}";

          const blob = new Blob([html], { type: "text/html" });
          const url = URL.createObjectURL(blob);
          const width = window.innerWidth / 1.5;
          const height = window.innerHeight / 1.5;
          const left = window.screenX + window.innerWidth / 4;
          const top = window.screenY + window.innerHeight / 4;
          window.open(
            url,
            "_blank",
            `width=${width},height=${height},left=${left},top=${top}`
          );
        }}
      >
        Live voorbeeld
      </Button>
    )}
  </Box>
);
